import { AutoMap } from "@automapper/classes";


export class ProcessCalculationDTO {
    @AutoMap()
    duration!: number;
    @AutoMap()
    samplingMode!: number;

}